module.exports = "/_next/static/images/f46f4e0d6b09b1a3f50176a36c666e4f-logo-fondo-ahorro-xs.png.webp";